/* ============================================
   KRHU Preorder System JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Configuration (injected from Liquid via data attributes on #preorder-config) --- */
  function getConfig() {
    var el = document.getElementById('preorder-config');
    if (!el) return null;
    return {
      enabled: el.getAttribute('data-enabled') === 'true',
      nextCutoff: el.getAttribute('data-next-cutoff') || '',
      cycleDays: parseInt(el.getAttribute('data-cycle-days'), 10) || 15,
      batchCount: el.getAttribute('data-batch-count') || '',
      batchCapacity: el.getAttribute('data-batch-capacity') || ''
    };
  }

  /* --- Date Utilities --- */
  function parseDateUTC(dateStr) {
    var parts = dateStr.split('-');
    return new Date(Date.UTC(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)));
  }

  function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function formatDateShort(date) {
    var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    return months[date.getUTCMonth()] + ' ' + date.getUTCDate();
  }

  function formatDateFull(date) {
    var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    return months[date.getUTCMonth()] + ' ' + date.getUTCDate() + ', ' + date.getUTCFullYear();
  }

  /* --- Batch Cutoff Calculator --- */
  function getNextCutoff(config) {
    var cutoff = parseDateUTC(config.nextCutoff);
    var now = new Date();
    var nowUTC = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds()));

    // Roll forward if cutoff is in the past
    while (cutoff.getTime() <= nowUTC.getTime()) {
      cutoff = addDays(cutoff, config.cycleDays);
    }
    return cutoff;
  }

  function getShipDateRange(cutoffDate) {
    var shipStart = addDays(cutoffDate, 14);
    var shipEnd = addDays(cutoffDate, 18);
    return { start: shipStart, end: shipEnd };
  }

  function getDeliveryDateRange(cutoffDate) {
    var deliveryStart = addDays(cutoffDate, 19);
    var deliveryEnd = addDays(cutoffDate, 25);
    return { start: deliveryStart, end: deliveryEnd };
  }

  /* --- Countdown Timer --- */
  function updateCountdown(cutoffDate) {
    var timerEls = document.querySelectorAll('[data-preorder-countdown-timer]');
    var dateEls = document.querySelectorAll('[data-preorder-countdown-dates]');

    if (!timerEls.length) return;

    var now = new Date();
    var diff = cutoffDate.getTime() - now.getTime();

    if (diff <= 0) {
      // Cutoff passed — reload to get new cutoff
      window.location.reload();
      return;
    }

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    var timerHTML =
      '<span class="preorder-countdown__unit"><span class="preorder-countdown__number">' + days + '</span><span class="preorder-countdown__label">d</span></span>' +
      '<span class="preorder-countdown__unit"><span class="preorder-countdown__number">' + hours + '</span><span class="preorder-countdown__label">h</span></span>' +
      '<span class="preorder-countdown__unit"><span class="preorder-countdown__number">' + minutes + '</span><span class="preorder-countdown__label">m</span></span>';

    timerEls.forEach(function (el) {
      el.innerHTML = timerHTML;
    });

    var shipRange = getShipDateRange(cutoffDate);
    var datesHTML = 'order by ' + formatDateShort(cutoffDate) + ' → ships ' + formatDateShort(shipRange.start) + ' – ' + formatDateShort(shipRange.end);

    dateEls.forEach(function (el) {
      el.textContent = datesHTML;
    });
  }

  /* --- Announcement Bar --- */
  function initAnnouncementBar() {
    var bar = document.getElementById('preorder-announcement');
    if (!bar) return;

    var dismissKey = 'krhu_preorder_announcement_dismissed';
    var dismissed = localStorage.getItem(dismissKey);

    if (dismissed) {
      var dismissedTime = parseInt(dismissed, 10);
      var hoursSince = (Date.now() - dismissedTime) / (1000 * 60 * 60);
      if (hoursSince < 24) {
        bar.setAttribute('hidden', '');
        return;
      } else {
        localStorage.removeItem(dismissKey);
      }
    }

    bar.removeAttribute('hidden');

    var closeBtn = bar.querySelector('.preorder-announcement__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.setAttribute('hidden', '');
        localStorage.setItem(dismissKey, String(Date.now()));
      });
    }
  }

  /* --- Dynamic Labels & Button State --- */
  function updatePreorderState() {
    var config = getConfig();
    if (!config || !config.enabled) return;

    var productDataEl = document.getElementById('preorder-product-data');
    if (!productDataEl) return;

    var hasPreorderTag = productDataEl.getAttribute('data-preorder-tag') === 'true';

    // Get current variant availability
    var cartBtn = document.querySelector('.product-info__cart-btn');
    if (!cartBtn) return;

    var variants = window.productVariants || [];
    var allSoldOut = !variants.some(function (v) { return v.available; });

    // Find current selected variant
    var currentVariantId = null;
    var idInput = document.querySelector('#AddToCartForm input[name="id"]');
    if (idInput) {
      currentVariantId = parseInt(idInput.value, 10);
    }

    var currentVariant = null;
    if (currentVariantId) {
      currentVariant = variants.find(function (v) { return v.id === currentVariantId; });
    }

    var isAvailable = currentVariant ? currentVariant.available : false;

    // Update labels
    var labelEls = document.querySelectorAll('[data-preorder-label]');
    var countdownEls = document.querySelectorAll('[data-preorder-countdown-wrapper]');
    var estimateEls = document.querySelectorAll('[data-preorder-delivery-estimate]');
    var batchEls = document.querySelectorAll('[data-preorder-batch-progress]');

    if (isAvailable) {
      // In stock — pre-made
      labelEls.forEach(function (el) {
        el.textContent = 'pre-made';
        el.className = 'preorder-label preorder-label--premade';
      });
      countdownEls.forEach(function (el) { el.style.display = 'none'; });
      batchEls.forEach(function (el) { el.style.display = 'none'; });
      estimateEls.forEach(function (el) {
        el.innerHTML = '<span class="preorder-delivery-estimate__icon">✓</span>in stock, ships next business day';
        el.style.display = '';
      });

      // Restore normal button
      cartBtn.classList.remove('preorder-btn', 'krhu-restock-trigger');
      cartBtn.type = 'submit';
      cartBtn.disabled = false;

    } else if (hasPreorderTag && !allSoldOut) {
      // Out of stock variant but preorder enabled — show preorder
      var cutoff = getNextCutoff(config);
      var delivery = getDeliveryDateRange(cutoff);

      labelEls.forEach(function (el) {
        el.textContent = 'pre-order';
        el.className = 'preorder-label preorder-label--preorder';
      });
      countdownEls.forEach(function (el) { el.style.display = ''; });
      batchEls.forEach(function (el) { el.style.display = ''; });
      estimateEls.forEach(function (el) {
        el.innerHTML = 'pre-order — estimated delivery: ' + formatDateShort(delivery.start) + ' – ' + formatDateShort(delivery.end);
        el.style.display = '';
      });

      // Change button to preorder
      var price = currentVariant ? currentVariant.price : (variants[0] ? variants[0].price : 0);
      var symbol = window.currencySymbol || '$';
      cartBtn.classList.add('preorder-btn');
      cartBtn.classList.remove('krhu-restock-trigger');
      cartBtn.type = 'submit';
      cartBtn.disabled = false;
      cartBtn.textContent = 'pre-order — ' + symbol + (price / 100).toFixed(2);

      // Re-enable the form to allow adding to cart for preorder
      if (idInput && currentVariant) {
        idInput.value = currentVariant.id;
      }

    } else if (hasPreorderTag && allSoldOut) {
      // All variants sold out but preorder enabled
      var cutoff2 = getNextCutoff(config);
      var delivery2 = getDeliveryDateRange(cutoff2);

      labelEls.forEach(function (el) {
        el.textContent = 'pre-order';
        el.className = 'preorder-label preorder-label--preorder';
      });
      countdownEls.forEach(function (el) { el.style.display = ''; });
      batchEls.forEach(function (el) { el.style.display = ''; });
      estimateEls.forEach(function (el) {
        el.innerHTML = 'pre-order — estimated delivery: ' + formatDateShort(delivery2.start) + ' – ' + formatDateShort(delivery2.end);
        el.style.display = '';
      });

      // For preorder, the button should still work (allow oversell)
      var firstVariant = variants[0];
      var price2 = firstVariant ? firstVariant.price : 0;
      var symbol2 = window.currencySymbol || '$';
      cartBtn.classList.add('preorder-btn');
      cartBtn.classList.remove('krhu-restock-trigger');
      cartBtn.type = 'submit';
      cartBtn.disabled = false;
      cartBtn.textContent = 'pre-order — ' + symbol2 + (price2 / 100).toFixed(2);

      if (idInput && firstVariant) {
        idInput.value = firstVariant.id;
      }

    } else {
      // Sold out, no preorder
      labelEls.forEach(function (el) {
        el.textContent = 'sold out';
        el.className = 'preorder-label preorder-label--soldout';
      });
      countdownEls.forEach(function (el) { el.style.display = 'none'; });
      batchEls.forEach(function (el) { el.style.display = 'none'; });
      estimateEls.forEach(function (el) { el.style.display = 'none'; });
      // Let the existing restock handler do its thing
    }
  }

  /* --- Hook into Variant Changes --- */
  function hookVariantUpdates() {
    // Observe changes to the hidden variant ID input
    var idInput = document.querySelector('#AddToCartForm input[name="id"]');
    if (!idInput) return;

    var observer = new MutationObserver(function () {
      setTimeout(updatePreorderState, 50);
    });

    observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });

    // Also hook into option button clicks
    document.querySelectorAll('.option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(updatePreorderState, 100);
      });
    });
  }

  /* --- Cart Preorder Notice --- */
  function initCartNotice() {
    var noticeEl = document.getElementById('preorder-cart-notice');
    if (!noticeEl) return;

    var config = getConfig();
    if (!config || !config.enabled) {
      noticeEl.style.display = 'none';
      return;
    }

    // Check if any cart items have preorder tag (set via Liquid data attribute)
    var hasPreorderItems = noticeEl.getAttribute('data-has-preorder') === 'true';
    if (!hasPreorderItems) {
      noticeEl.style.display = 'none';
      return;
    }

    var cutoff = getNextCutoff(config);
    var delivery = getDeliveryDateRange(cutoff);
    var dateText = document.getElementById('preorder-cart-notice-dates');
    if (dateText) {
      dateText.textContent = 'your cart contains pre-order items. estimated delivery: ' + formatDateShort(delivery.start) + ' – ' + formatDateShort(delivery.end);
    }
    noticeEl.style.display = '';
  }

  /* --- Update Announcement Bar Date --- */
  function updateAnnouncementDate() {
    var config = getConfig();
    if (!config || !config.enabled) return;

    var dateEl = document.getElementById('preorder-announcement-date');
    if (!dateEl) return;

    var cutoff = getNextCutoff(config);
    dateEl.textContent = formatDateShort(cutoff);
  }

  /* --- Init --- */
  function init() {
    var config = getConfig();
    if (!config || !config.enabled) return;

    initAnnouncementBar();
    updateAnnouncementDate();

    var cutoff = getNextCutoff(config);

    // Start countdown
    updateCountdown(cutoff);
    setInterval(function () {
      var latestCutoff = getNextCutoff(config);
      updateCountdown(latestCutoff);
    }, 60000); // Update every minute

    // Dynamic labels on product page
    updatePreorderState();
    hookVariantUpdates();

    // Cart notice
    initCartNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });
})();
